export const standardBenefit = [
  {
    text: '경공매 기본정보 + 상세 권리분석',
    number: '월 1,000건',
  },
  {
    text: 'AI 경공매 찾기',
    number: '월 1000건',
  },
  {
    text: 'VIP 퀀트 분석 리포트',
    number: '월 100건',
  },
  {
    text: 'AI 경매 알고리즘 만들기',
    number: '월 100건',
  },
  {
    text: '등기부등본/전입세대열람원',
    number: '월 1000건',
  },
  {
    text: '월간 경매 통계 조회',
    number: '',
  },
];

export const premiumBenefit = [
  {
    text: '경공매 기본정보 + 상세 권리분석',
    number: '무제한',
  },
  {
    text: 'AI 경공매 찾기',
    number: '무제한',
  },
  {
    text: 'VIP 퀀트 분석 리포트',
    number: '무제한',
  },
  {
    text: 'AI 경매 알고리즘 만들기',
    number: '무제한',
  },
  {
    text: '등기부등본/전입세대열람원',
    number: '무제한',
  },
  {
    text: '주간/월간 경매 통계 조회',
    number: '',
  },
  {
    text: 'NPLatform(부실채권 플랫폼)',
    number: '월 100건',
  },
  {
    text: '전문가 상담 서비스',
    number: '월 30분',
  },
  // {
  //   text: '사용자 맞춤형 부동산 물건 분석',
  //   number: '',
  // },
];
